export const TABLE_HEADERS_USER_MANAGEMENT = [
  {
    label: "User Name",
    key: "user_name",
  },
  {
    label: "Email",
    key: "email",
  },
  {
    label: "Phone Number",
    key: "phone_number",
  },
  {
    label: "Designation",
    key: "designation",
  },
  {
    label: "Top Session",
    key: "top_session",
  },
  {
    label: "Subscription",
    key: "sub_type",
  },
  {
    label: "Status",
    key: "subscription_status",
  },
  {
    label: "Sessions",
    key: "sessions",
  },
  {
    label: "Language",
    key: "language",
  },
  {
    label: "Date Joined",
    key: "date_joined",
  },
  {
    label: "OpenAI Cost",
    key: "openai_cost",
  },
  {
    label: "Elevenlab Cost",
    key: "elevenlab_cost",
  },
  {
    label: "Total Spend",
    key: "total_spend",
  },
];

export const SEARCH_CONFIG_USER_MANAGEMENT = {
  column: "User Name",
  placeholder: "Search by user name...",
};

export const TABLE_HEADERS_REVIEW_MANAGEMENT = [
  {label: "User Name", key: "full_name"},
  {label: "Session Name", key: "session_title"},
  {label: "Rating", key: "ratings"},
  {label: "Review Snippet", key: "review"},
  {label: "language", key: "language"},
  {label: "Submitted On", key: "created_at"},
  {label: "Status", key: "status"},
];

export const SEARCH_CONFIG_REVIEW_MANAGEMENT = {
  column: "Session Name",
  placeholder: "Search by Name...",
};
